import Axios from 'axios';
const STORAGE_KEYS = {Token: 'token'};
const SERVICE = 'prwsm';
const MIN2S = 1000;
const MIN2MS = 60 * MIN2S;
const HOUR2MS = 60 * MIN2MS;
const DAY2MS = 24 * HOUR2MS;
var TOKEN = null;

export default class Services {
	// TOKEN
	static getToken() {
		// if TOKEN is null check the LS
		 if (TOKEN == null)
			TOKEN =	localStorage.getItem(STORAGE_KEYS.Token);

		return TOKEN;
	}

	static setToken(token, rememberMe) {
		// keep in global variable
		TOKEN = token;

		// keep in LS
		 if (rememberMe)
			localStorage.setItem(STORAGE_KEYS.Token, token);
	}

	static clearLocalStorage(){
		// set global variable to null
		TOKEN = null;
			
		// clear local storage
		localStorage.removeItem(STORAGE_KEYS.Token);
		localStorage.removeItem('user');
		localStorage.removeItem('comp');
	}

	// WEB SERVICES
	static async get(url, callback) {
		const token = this.getToken();
		// if (url.indexOf('https') !== -1)
		// 	url = `/${SERVICE}/${url}?t=${token}`;
		// if (window.location.href.indexOf('localhost') !== -1) 
		// 	url = 'http://localhost' + url;
		const res = await Axios.get(url);
		return callback(res.data);
	}

	static async post(url, data) {
		const token = this.getToken();
		url = `/${SERVICE}/${url}`;
		if (window.location.href.indexOf('localhost') !== -1) 
			url = 'http://localhost' + url;

		const res = await Axios({
			method: 'post',
			url,
			data,
			headers: { 'Authorization': token }
		});
		return res.data;
	}

	static isCompany() {
		let comp = this.getCompany();
		return comp != null;
	}

	static getCompany() {
		return JSON.parse(localStorage.getItem("comp"));
	}

	static getUser() {
		return JSON.parse(localStorage.getItem("user"));
	}


	static getRights() {
		return JSON.parse(localStorage.getItem("rights"));
	}

	static getSettings() {
		return JSON.parse(localStorage.getItem("mapsettings"));
	}

	static getFrameTxt() {
        let gmapsBoundaries = this.map.getBounds();
        let p = 100;
        let minlat = Math.floor(gmapsBoundaries.getSouthWest().lat() * p) / p;
        let minlon = Math.floor(gmapsBoundaries.getSouthWest().lng() * p) / p;
        let maxlat = Math.ceil(gmapsBoundaries.getNorthEast().lat() * p) / p;
        let maxlon = Math.ceil(gmapsBoundaries.getNorthEast().lng() * p) / p;

        let frame = minlat + "," + minlon + "," + maxlat + "," + maxlon;
        return frame;
	}

	static timestampConverter(timestamp){
		let a = new Date(timestamp * 1000);
		let months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
		let year = a.getFullYear();
		let month = months[a.getMonth()];
		let date = a.getDate();
		let hour = a.getHours();
		let min = a.getMinutes();
		let sec = a.getSeconds();
		let time = date + ' ' + month + ' ' + year + ' ' + hour + ':' + min + ':' + sec ;
		return time;
	}

	static timeOnlyConverter(timestamp){

		// Create a new JavaScript Date object based on the timestamp
		// multiplied by 1000 so that the argument is in milliseconds, not seconds.
		var date = new Date(timestamp * 1000);
		// Hours part from the timestamp
		var hours = date.getHours();
		// Minutes part from the timestamp
		var minutes = "0" + date.getMinutes();

		// Will display time in 10:30:23 format
		var formattedTime = hours + ':' + minutes.substr(-2);
		
		return formattedTime;
	}

	static getTimeFromNow(date) {
       
        var diff = new Date().getTime() - date;
        if (diff < 0)
            return "";

        var msec = diff
        var days = Math.floor(msec / DAY2MS);
        if (days > 0)
            return days + "d";

        msec -= days * DAY2MS;
        var hh = Math.floor(msec / HOUR2MS);
        if (hh > 0)
            return hh + "h";

        msec -= hh * HOUR2MS;
        var mm = Math.floor(msec / MIN2MS);
        if (mm > 0)
            return mm + "m";

        msec -= mm * MIN2MS;
        var ss = Math.floor(msec / MIN2S);
        return ss + "s";
	}
	
	static dateConverter(date, format) {
        if (date === null)
            return "";

        if (format === null || format === "")
            format = "dd/MM/yyyy";

        // If we receive a timestamp we convert
        if (typeof date === 'number') {
            date = new Date(date);
        }

        let hh = date.getHours();
        let mm = date.getMinutes();
        //let days = GetString("days_short").split("_");
        //let months = GetString("months_long").split("_");

        let res = format;
        //res = res.replace("MMMM", months[MM - 1]);
        if (res === undefined)
            return;
        res = res.replace("hh", this.FormatIntWithZeros(hh, 2));
        res = res.replace("mm", this.FormatIntWithZeros(mm, 2));

        //res = res.replace("D", days[D]);

        return res;
	}
	
	static FormatIntWithZeros(i, nb) {
        let res = "" + i;
        while (res.length < nb)
            res = "0" + res;
        return res;
    }

}
